/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CriteriaContentObject } from '../../models/criteria-content-object';
import { StatContent } from '../../models/stat-content';

export interface ApiMasterStatContentGetByCriteriaPost$Params {
      body?: CriteriaContentObject
}

export function apiMasterStatContentGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterStatContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StatContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterStatContentGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<StatContent>>;
    })
  );
}

apiMasterStatContentGetByCriteriaPost.PATH = '/api/Master/StatContent/GetByCriteria';
